"use strict";
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.SearchResultsHeader = void 0;
var _mui = require("@ori-ui/mui");
var _analyticsData = require("@ori/analytics-data");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _useTranslations = require("../../hooks/useTranslations");
var _SearchResultsHeaderSkeleton = require("../SearchResultsHeaderSkeleton");
var _constants = require("./constants");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
/**
 * Search results header component. This component is used to display the search query.
 */ const SearchResultsHeader = (param)=>{
    let { query, className, loaded, queries } = param;
    const { getTestId } = (0, _testidGenerator.default)();
    const { translations, formatMessage } = (0, _useTranslations.useTranslations)();
    const { brands = [], categories = [], searchedTerm } = queries !== null && queries !== void 0 ? queries : {};
    const usedQuery = searchedTerm !== null && searchedTerm !== void 0 ? searchedTerm : query;
    if (!loaded) {
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)(_SearchResultsHeaderSkeleton.SearchResultsHeaderSkeleton, {
            className: className
        });
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_styles.Root, {
        "data-testid": getTestId(_constants.SEARCH_RESULTS_HEADER),
        className: className,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_styles.Inner, {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_mui.Typography, {
                        fontWeight: "bold",
                        variant: "h5",
                        component: "h1",
                        align: "center",
                        color: "textPrimary",
                        children: translations.showingResultsFor
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_styles.Query, {
                        component: "h2",
                        align: "center",
                        color: "textPrimary",
                        children: "”".concat(usedQuery !== null && usedQuery !== void 0 ? usedQuery : '', "”")
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_styles.QueriesContainer, {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_styles.StyledQueryListSection, {
                        title: formatMessage('brandsX', {
                            count: brands.length
                        }),
                        items: brands,
                        query: usedQuery !== null && usedQuery !== void 0 ? usedQuery : '',
                        showIcon: false,
                        placement: _analyticsData.Placement.SearchSuggestions
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_styles.StyledQueryListSection, {
                        title: formatMessage('categoriesX', {
                            count: categories.length
                        }),
                        items: categories,
                        query: usedQuery !== null && usedQuery !== void 0 ? usedQuery : '',
                        showIcon: false,
                        placement: _analyticsData.Placement.SearchSuggestions
                    })
                ]
            })
        ]
    });
};
exports.SearchResultsHeader = SearchResultsHeader;
